<template>
  <div class="search-box">
    <input
      type="text"
      v-model="inputVal"
      class="main-input"
      v-on:keydown="enterKey($event)"
      v-on:focus="inputFocus"
      v-on:input="inputChange($event.target.value)"
      :placeholder="$t('service.searchProblems')"
    />

    <!-- <img src="./img/search.svg" class="search-icon"> -->
    <svg
      version="1.1"
      class="search-icon"
      @click="emitData"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 12 12"
      style="enable-background:new 0 0 12 12;"
      xml:space="preserve"
    >
      <path
        class="st0"
        d="M11.7,10.4L9.1,7.8C9.7,7,10,6,10,5c0-2.8-2.2-5-5-5S0,2.2,0,5s2.2,5,5,5c1,0,2-0.3,2.8-0.9l2.6,2.6
	c0.4,0.4,1,0.4,1.4,0C12.1,11.3,12.1,10.7,11.7,10.4z M5,8C3.3,8,2,6.7,2,5s1.3-3,3-3s3,1.3,3,3S6.7,8,5,8z"
      />
    </svg>

    <transition name="fade">
      <div
        ref="options"
        class="k-popover"
        v-if="showPopover && outputData && outputData.length > 0 && inputVal"
      >
        <div class="scroll-wrap" id="scroll-wrap">
          <ul class="k-ul" id="k-ul">
            <li
              v-for="item in outputData"
              :class="{ on: item.index === selectedItem.index }"
              :key="item.id"
              @click="selectOption(item)"
            >
              {{ item.question_title }}
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
function uDebounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;

  var later = function() {
    var last = new Date().getTime() - timestamp;

    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function() {
    context = this;
    args = arguments;
    timestamp = new Date().getTime();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

export default {
  name: "search",
  props: ["dataFunc", "selGame", "searchType", "searchOptions"],
  data() {
    return {
      inputVal: "",
      showPopover: false,
      selectedItem: {
        id: 0,
      },
      outputData: [],
      entered: false,
      fetching: true,
    };
  },
  methods: {
    inputFocus() {
      if (this.inputVal) {
        this.showPopover = true;
        this.computStyle();
      }
    },
    inputChange: uDebounce(function(val) {
      this.filterData(val);
    }, 400),
    filterData(val) {
      var _this = this;
      this.fetching = true;
      this.outputData = [];
      var type = this.searchType;
      if (type === 0) {
        type = "";
      }
      this.dataFunc(
        this.selGame.game_base_id,
        type,
        this.searchOptions.index,
        this.searchOptions.size,
        val
      ).then((data) => {
        _this.outputData = data.data.data.result;
        if (!val) {
          _this.showPopover = false;
        } else {
          _this.showPopover = true;
          _this.computStyle();
        }

        if (_this.entered) {
          _this.emitData();
        }
        _this.entered = false;
        _this.fetching = false;
      });
    },
    enterKey(e) {
      if (e.keyCode === 13) {
        this.emitData();
        if (this.fetching) {
          this.entered = true;
        }
      } else {
        this.fetching = true;
      }
    },
    emitData() {
      this.$emit("searchValChanged", this.outputData, this.inputVal);
    },
    selectOption(item) {
      this.inputVal = item.question_title;
      this.showPopover = false;
      this.$emit("searchValChanged", [item]);
    },
    computStyle() {
      /**
       * 修改scroll-wrap的样式以清除滚动框
       */
      this.$nextTick(function() {
        var scrollWrap = document.getElementById("scroll-wrap"),
          kUl = document.getElementById("k-ul");
        if (scrollWrap && kUl) {
          scrollWrap.style.marginRight =
            kUl.offsetWidth - scrollWrap.offsetWidth + "px";
          scrollWrap.style.marginBottom =
            kUl.offsetWidth - scrollWrap.offsetWidth + "px";
        }
      });
    },
    resetInput() {
      this.inputVal = "";
    },
  },
  created() {},
  mounted() {
    var _this = this;

    document.onclick = function(e) {
      var cName = (e.target.parentNode && e.target.parentNode.className) || "";
      if (typeof cName === "string") {
        if (
          cName !== "k-ul" &&
          cName !== "scroll-wrap" &&
          cName !== "k-popover" &&
          cName.indexOf("search-box") === -1
        ) {
          _this.showPopover = false;
        }
      }
    };
  },
  watch: {
    datas: function(newVal) {
      if (newVal) {
        this.searchItems = newVal;
      }
    },
  },
//    beforeDestroy() {
//     //    console.log(1)
//     /* 组件销毁的时候要移除侦听器 */
//      this.$refs.options.remove();
//   },
};
</script>

<style lang="scss" scoped>
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #ccc;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ccc;
}
.search-box {
  position: relative;
}
.main-input {
  width: 100%;
  height: 100%;
  border: 1px solid #cccccc;
  border-radius: 100px;
  text-indent: 20px;
  box-sizing: border-box;
}
.search-icon {
  position: absolute;
  top: 9px;
  right: 20px;
  width: 12px;
  height: 12px;
  fill: #ccc;
  cursor: pointer;
  &:hover {
    fill: #50bbe5;
  }
}
.k-popover {
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  max-height: 274px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow: hidden;
}
.scroll-wrap {
  max-height: 274px;
  overflow: scroll;
}
.k-ul {
  margin: 0;
  padding: 0;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  li {
    position: relative;
    padding: 0 20px;
    height: 34px;
    color: #606266;
    line-height: 34px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    list-style-type: none;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      background-color: #f5f7fa;
    }
    &.on {
      color: #50bbe5;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
